import React from 'react'
import axios from "axios";
import { useState, useEffect } from "react"
import {serverLink} from "../../../resources/url";
import Loader from '../../common/loader/loader';
import { connect } from 'react-redux';
import {setLoginDetails, setLogInDetails} from "../../../actions/actions";
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";
import {decryptData, projectLogo, projectName} from "../../../resources/constants";
function useQuery() {
    return new URLSearchParams(useLocation().search);
}


const PaymentLogin = (props) => {
    const navigate = useNavigate();
    let query = useQuery();
    const user_id = decryptData(query.get("user"));
    const email_address = decryptData(query.get("email"));
    const user_type = decryptData(query.get("type"));
    const [loading, setIsLoading] = useState(true)

    // const user_id = props.loginData[0].StudentID;
    // const email_address = props.loginData[0].email_address;
    // const user_type = props.loginData[0].user_type;

    const onLogin = async () => {
        const sendData = {
            user_type: user_type,
            user_id: user_type === 'returning' ? btoa(user_id) : user_id,
            email_address: email_address
        }
        axios.post(`${serverLink}payment/login`, sendData).then((result) => {
            const res = result.data;
            const message = res.message;
            if (message === 'success') {
                toast.success('Login successfully.');
                props.setOnLogInDetails({...res, userType: user_type});
                props.setOnSystemLogInDetails([{...res, userType: user_type}]);
                setTimeout(function () {
                    window.location.href = '/portal/payment/dashboard';
                    // navigate("/portal/payment/dashboard");
                    setIsLoading(false);
                }, 100)
            }else{
                if (message === 'invalid_id')
                    toast.error('Invalid ID. Please check your ID and try again');
                else if (message === 'invalid_email')
                    toast.error('Invalid Email. Please check your Email Address and try again!');
                else
                    toast.error('Invalid Login Credential. Please check your Login Credential and try again!');
            }
        }).catch(error => {
            toast.error('Network Error');
            console.log(error)
        });
    }

    useEffect(() => {
        if (query.get("user") && query.get("email") && query.get("type")) {
            onLogin();
        } else {
            setIsLoading(false);
            console.log("Query parameters missing or invalid");
        }
    }, []);

    return loading ? (
        <Loader />
    ) : (
        <div className="error-page">
            <div className="main-wrapper">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xxl-8 col-xl-8 col-md-8">
                        <div className="d-flex flex-column justify-content-between vh-100">
                            <div className="text-center p-4">
                                {/*<img src={projectLogo} alt="img" className="img-fluid"/>*/}
                            </div>
                            <div className="d-flex flex-column align-items-center justify-content-center mb-4">
                                <div className="mb-4">
                                    <img src={projectLogo} className="img-fluid" alt="Img"/>
                                </div>
                                <h3 className="h1 mb-3 text-center">Welcome to Hensard University Payment Portal</h3>
                                <p className="text-center">
                                    All student-related or admission payments must be made through the official Hensard University Student or Admission Portal for proper verification and record keeping.

                                    Kindly return to your respective portal to proceed with payment. Thank you for your cooperation.
                                </p>
                                <div className="d-flex">
                                    <a href="https://student.hensarduniversity.edu.ng/" target={'_blank'} referrerPolicy={'no-referrer'} className="btn btn-primary d-flex align-items-center m-1"><i className="ti ti-arrow-left me-2"></i>Student Portal</a>
                                    <a href="https://admission.hensarduniversity.edu.ng/" target={'_blank'} referrerPolicy={'no-referrer'} className="btn btn-primary d-flex align-items-center ml-2 m-1">Admission Portal <i className="ti ti-arrow-right ms-2"></i></a>
                                </div>
                            </div>
                            <div className="text-center p-3">
                                <p>Copyright &copy; 2025 - {projectName}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )

}
const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
        paymentLoginDetails: state.paymentLoginDetails,
        currentSemester: state.currentSemester
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLogInDetails: (p) => {
            dispatch(setLogInDetails(p));
        },
        setOnSystemLogInDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentLogin);
